<div class="bg-gradient-primary">
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                    <div>
                      <img
                        style="object-fit: cover"
                        [src]="retrievedImage"
                      />
                      <br /><br />
                    </div>
                    <h1 class="h4 text-gray-900 mb-4">Chào mừng trở lại!</h1>
                  </div>

                  <form
                    class="user"
                    #loginForm="ngForm"
                    (ngSubmit)="doLogin(loginForm)"
                  >
                    <div class="form-group">
                      <input
                        class="form-control form-control-user"
                        id="exampleInputEmail"
                        aria-describedby="emailHelp"
                        placeholder="Tên đăng nhập"
                        name="username"
                        [(ngModel)]="username"
                        type="text"
                        value="admin"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        class="form-control form-control-user"
                        id="exampleInputPassword"
                        placeholder="Mật khẩu"
                        name="password"
                        [(ngModel)]="password"
                        value="admin"
                      />
                    </div>
                    <div class="form-group">
                       <div class="custom-control custom-checkbox small">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customCheck"
                        />
                        <label class="custom-control-label" for="customCheck"
                          >Ghi nhớ đăng nhập</label
                        >
                      </div> 
                    </div>
                    <button
                      *ngIf="!buttonLoginClicked; else loaded"
                      type="submit"
                      class="btn btn-primary btn-user btn-block"
                    >
                    <i class="fas fa-sign-in-alt"></i>
                    Đăng nhập
                    </button>
                    <hr />
                 <!--     <a
                    href="index.html"
                    class="btn btn-google btn-user btn-block"
                  >
                    <i class="fab fa-google fa-fw"></i> Login with Google
                  </a>
                  <a
                    href="index.html"
                    class="btn btn-facebook btn-user btn-block"
                  >
                    <i class="fab fa-facebook-f fa-fw"></i> Login with Facebook
                  </a>  -->
                    
                    <ng-template #loaded>
                      <div>
                        <div class="d-flex justify-content-center">
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          >
                            <span class="sr-only">Đang tải...</span>
                          </div>
                        </div>
                      </div>
                    </ng-template>

                    
                  </form>
                  <br>
                  <div class="text-center">
                  <a class="small" routerLink="/forgot-password"
                    >Quên mật khẩu?</a
                  >
                </div>
                <div class="text-center">
                  <a class="small" 
                  routerLink="/register">Tạo tài khoản</a>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
